import React from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import { Divider, Typography } from "@mui/material";
import * as Styled from "./styles";
import { useTranslation } from "react-i18next";

interface RightSideMenuProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string | null | undefined;
  children: React.ReactNode;
}

const RightSideMenu: React.FC<RightSideMenuProps> = ({
  isOpen,
  onClose,
  title = null,
  children,
}) => {
  const { t } = useTranslation();
  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <Styled.Overlay isOpen={isOpen} onClick={handleOverlayClick} />
      <Styled.MenuContainer isOpen={isOpen}>
        <Styled.MenuHeader>
          {title && (
            <>
              <Styled.MenuTitle variant="h6">{title}</Styled.MenuTitle>
              <Divider />
            </>
          )}
          <Styled.CloseButton
            onClick={onClose}
            color="primary"
            aria-label="Fechar menu"
          >
            <CloseIcon color="primary" />
            <Typography variant="body2" color="primary">
              {t("close").toUpperCase()}
            </Typography>
          </Styled.CloseButton>
        </Styled.MenuHeader>

        <Styled.MenuContent>{children}</Styled.MenuContent>
      </Styled.MenuContainer>
    </>
  );
};

export default RightSideMenu;
